import {commonPromise} from '../../http'
import {
    COURSE_LIST,
    QUERY_MUSEUM_DETAILS,
    PUBLISH_STATE,
    QUERY_SHOW_ROOM,
    SAVE_USER_GUIDE,
    QUERY_EXHIBITS
} from '../global'


export const courseListFetch = (data) => commonPromise(data, COURSE_LIST);// 课程列表
export const queryMuseumDetails = (data) => commonPromise(data, QUERY_MUSEUM_DETAILS)// 博物馆详情
export const publishState = (data) => commonPromise(data, PUBLISH_STATE, 'get')
export const showRoom = (data) => commonPromise(data, QUERY_SHOW_ROOM)// 导览详情
export const saveUserGuide = (data) => commonPromise(data, SAVE_USER_GUIDE)// 添加用户记录
export const queryExhibits = (data) => commonPromise(data, QUERY_EXHIBITS)// 播放列表



// WEBPACK FOOTER //
// ./src/api/apiModules/guideApi.js